import { render, staticRenderFns } from "./FormLabel.vue?vue&type=template&id=7a40257f&scoped=true&"
import script from "./FormLabel.vue?vue&type=script&lang=js&"
export * from "./FormLabel.vue?vue&type=script&lang=js&"
import style0 from "./FormLabel.vue?vue&type=style&index=0&id=7a40257f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a40257f",
  null
  
)

export default component.exports